// src/components/PriorityBadge.jsx
import React from "react";

const priorityColors = {
  Low: "bg-green-100 text-green-800",
  Medium: "bg-yellow-100 text-yellow-800",
  High: "bg-orange-100 text-orange-800",
  Critical: "bg-red-100 text-red-800",
};

const PriorityBadge = ({ priority }) => {
  const colorClasses = priorityColors[priority] || "bg-gray-100 text-gray-800";

  return (
    <span
      className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${colorClasses}`}
    >
      {priority}
    </span>
  );
};

export default PriorityBadge;
